/* eslint no-undef:0 */

import appConfig from '../../appConfig';

Stripe.setPublishableKey(appConfig.stripe);

const CANADIAN_PROVINCES = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];
function isCanada(state) {
  return (CANADIAN_PROVINCES.indexOf(state) >= 0);
}

const PRICES = {
  'CAD': 250,
  'USD': 250
};

function getPriceForCurrency(currency) {
  return {
    currency: currency,
    amount: PRICES[currency]
  };
}

export function getPrice(profile) {
  if (isCanada(profile.stateOrProvince)) {
    return getPriceForCurrency('CAD');
  }
  return getPriceForCurrency('USD');
}

export function createCCToken($form) {
  return new Promise((resolve, reject) => {
    Stripe.card.createToken($form, (status, response) => {
      if (response.error) {
        reject(response.error);
      } else {
        resolve(response.id);
      }
    });
  });
}

function parseJsonResponse(xhrResponse) {
  if (!xhrResponse) return null;
  if (typeof xhrResponse !== 'string') return xhrResponse;
  try {
    return JSON.parse(xhrResponse);
  } catch (err) {
    return null;
  }
}

function ajax(method, endpoint, data, cb) {
  const xhr = new XMLHttpRequest();
  xhr.open(method, appConfig.apiUrl + endpoint, true);
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.addEventListener('readystatechange', () => {
    if (xhr.readyState !== XMLHttpRequest.DONE) return;
    if (xhr.status >= 400) {
      const error = new Error(['Request failed:', method, endpoint, 'returned', xhr.status, xhr.statusText].join(' '));
      error.response = xhr.response;
      error.responseType = xhr.responseType;
      cb(error, parseJsonResponse(xhr.response));
      return;
    }
    cb(null, parseJsonResponse(xhr.response));
  });
  xhr.send(data ? JSON.stringify(data) : null);
}

export function processCharge(data) {
  return new Promise((resolve, reject) => {
    ajax('POST', 'buySession', data, (err, response) => {
      if (err) return reject(err);
      resolve(response);
    });
  });
}

export function getValidUntilTime() {
  const now = new Date();
  const validUntil = new Date(now.getFullYear(), 5, 30); // June 30th
  if (validUntil < now) {
    validUntil.setYear(now.getFullYear() + 1);
  }
  return validUntil.getTime();
}



// WEBPACK FOOTER //
// ./src/services/payment.js